export default "__VITE_ASSET__CVyHLTaU__"